import { repliesConfig } from '@/lib/analytics/kpis/instagram/stories/replies';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const repliesMVConfig = {
    ...repliesConfig,
    id: 'replies',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
